import styled from "styled-components";


const Row = styled.div`
  max-width: 1800px;
  box-sizing: border-box;
  margin-left: auto;
  margin-right: auto;
  padding-left: 5%;
  padding-right: 5%;
  text-align: left;
`;

const ContentRow = styled(Row)`
  position: relative;
`;

export { Row, ContentRow };
